export const translations = {
  it: {
    nav: { home: "Home", hunt: "Caccia al tartufo", shop: "Negozio", about: "Chi siamo", contact: "Contatti", book: "Prenota" },
    hero: {
      eyebrow: "Langhe · Monferrato",
      title: "Alla ricerca dell'oro della terra",
      text: "Esperienze guidate di ricerca del tartufo con i nostri cani Milo e Stella, e tartufi freschi scelti uno a uno.",
      ctaPrimary: "Prenota l'esperienza",
      ctaSecondary: "Scopri i tartufi",
    },
    highlights: [
      { value: "2", label: "cani da tartufo addestrati" },
      { value: "Bianco & Nero", label: "i tartufi che cerchiamo" },
      { value: "Langhe", label: "e Monferrato, le nostre riserve" },
    ],
    experience: {
      eyebrow: "L'esperienza",
      title: "Caccia al tartufo guidata",
      text: "Scoprite con noi il fascino esclusivo della ricerca del tartufo nelle migliori riserve delle Langhe e del Monferrato. I nostri cani esperti vi porteranno alla scoperta dei preziosi tartufi bianchi e neri, tesori nascosti della nostra terra. Ogni ricerca si trasforma in un'avventura indimenticabile, ricca di emozioni e scoperte.",
      cta: "Prenota",
    },
    shop: {
      eyebrow: "Il negozio",
      title: "I nostri tartufi",
      text: "Una selezione di tartufi al dettaglio, disponibili per l'acquisto diretto. Ogni tartufo è scelto con cura per garantire qualità e freschezza.",
      order: "Ordina",
      more: "Leggi di più",
      less: "Mostra meno",
      pageTitle: "I nostri prodotti",
    },
    story: {
      eyebrow: "Chi siamo",
      title: "La nostra storia",
      text: "Siamo una coppia appassionata di ricerca del tartufo, accompagnata dai nostri fidati cani, alla scoperta dei preziosi tartufi bianchi e neri nelle campagne italiane. Offriamo esperienze guidate nelle migliori riserve delle Langhe e del Monferrato.",
      full: "Siamo una coppia appassionata di tartufi, accompagnati da due fedeli cani addestrati, che esplorano le rigogliose campagne italiane alla ricerca dei preziosi tartufi bianchi e neri. Non ci limitiamo a questa attività per passione, ma offriamo anche esperienze di ricerca guidata, permettendo agli appassionati di scoprire il mondo affascinante della tartuficoltura. Unitevi a noi per un'avventura nelle migliori riserve delle Langhe e del Monferrato, immergendovi nella tradizione e nella natura, mentre vi guidiamo attraverso boschi incantati alla scoperta di questi tesori nascosti.",
      cta: "Scopri di più",
      dogs: "I nostri cani",
    },
    booked: {
      eyebrow: "Esperienze",
      title: "Esperienze di ricerca del tartufo",
      subtitle: "Vivi un'avventura unica nel cuore delle Langhe e del Monferrato",
      description:
        "Unisciti a noi per un'esperienza indimenticabile nella ricerca del tartufo: un'avventura che ti porterà a esplorare i segreti di antiche foreste e a scoprire le tecniche tradizionali di raccolta. Le nostre esperienze guidate sono pensate per appassionati di tutte le età e livelli di esperienza.",
      includedTitle: "Cosa è incluso",
      included: [
        { title: "Guida esperta e cane da tartufo", description: "La tua guida sarà un esperto cercatore locale, accompagnato da un cane addestrato alla ricerca dei tartufi." },
        { title: "Degustazione del tartufo", description: "Al termine dell'escursione potrai gustare un assaggio di tartufo fresco, accompagnato da un bicchiere di vino e prodotti locali." },
        { title: "Fotografie dell'esperienza", description: "Immortaliamo i momenti salienti della tua avventura per ricordi che dureranno una vita." },
      ],
    },
    contact: {
      eyebrow: "Contatti",
      title: "Contattaci",
      text: "Compila il form per metterti in contatto con noi. Risponderemo il prima possibile.",
      name: "Nome",
      surname: "Cognome",
      email: "Email",
      message: "Messaggio",
      interestsTitle: "A cosa sei interessato?",
      interests: { hunt: "Caccia al tartufo", buy: "Acquistare tartufi", info: "Informazioni" },
      send: "Invia richiesta",
      sending: "Invio in corso…",
      success: "Richiesta inviata con successo. Ti risponderemo presto!",
      error: "Si è verificato un errore durante l'invio. Riprova tra poco.",
      mailFallback: "Abbiamo aperto la tua app email con il messaggio già pronto: premi Invia per spedirlo a Milo's Truffle.",
      direct: "Oppure scrivici direttamente",
      required: "Compila i campi obbligatori",
    },
    booking: {
      title: "Prenota la tua caccia al tartufo",
      people: "Numero di persone",
      tasting: "Con degustazione",
      noTasting: "Senza degustazione",
      days: "Giorni di preferenza",
      daysPlaceholder: "Indica eventuali giorni di preferenza…",
      allergies: "Hai allergie?",
      allergiesLabel: "Specifica le tue allergie",
      allergiesPlaceholder: "Inserisci eventuali allergie…",
    },
    order: {
      title: "Richiedi il tuo tartufo",
      intro: "Indica la quantità e i tuoi dati: riceverai una mail il prima possibile.",
      quantity: "Quantità in grammi",
      phone: "Telefono",
      address: "Indirizzo",
      note: "Note (opzionale)",
      cancel: "Annulla",
      send: "Invia ordine",
    },
    footer: {
      about:
        "Simone Gulino e Giulia Canton sono una coppia appassionata di tartufi. Insieme ai loro due fedeli cani, Milo e Stella, si dedicano alla ricerca di tartufi nelle campagne italiane e offrono esperienze guidate a tutti gli appassionati.",
      links: "Link utili",
      contacts: "Contatti",
      rights: "Tutti i diritti riservati.",
    },
    notFound: { title: "Pagina non trovata", text: "La pagina che cerchi non esiste o è stata spostata.", cta: "Torna alla home" },
  },
  en: {
    nav: { home: "Home", hunt: "Truffle hunt", shop: "Shop", about: "About", contact: "Contact", book: "Book" },
    hero: {
      eyebrow: "Langhe · Monferrato",
      title: "In search of the earth's gold",
      text: "Guided truffle hunting with our dogs Milo and Stella, plus fresh truffles chosen one by one.",
      ctaPrimary: "Book the experience",
      ctaSecondary: "Discover our truffles",
    },
    highlights: [
      { value: "2", label: "trained truffle dogs" },
      { value: "White & Black", label: "the truffles we hunt" },
      { value: "Langhe", label: "and Monferrato, our reserves" },
    ],
    experience: {
      eyebrow: "The experience",
      title: "Guided truffle hunting",
      text: "Discover with us the exclusive charm of truffle hunting in the best reserves of the Langhe and Monferrato. Our expert dogs will lead you to the precious white and black truffles, hidden treasures of our land. Every hunt turns into an unforgettable adventure, rich in emotions and discoveries.",
      cta: "Book now",
    },
    shop: {
      eyebrow: "The shop",
      title: "Our truffles",
      text: "A selection of truffles available for direct purchase. Each truffle is carefully chosen to guarantee quality and freshness.",
      order: "Order",
      more: "Read more",
      less: "Show less",
      pageTitle: "Our products",
    },
    story: {
      eyebrow: "About us",
      title: "Our story",
      text: "We are a passionate truffle-hunting couple, accompanied by our loyal dogs, exploring the Italian countryside in search of prized white and black truffles. We offer guided experiences in the finest reserves of the Langhe and Monferrato.",
      full: "We are a passionate truffle-hunting couple, accompanied by two loyal and trained dogs, exploring the lush Italian countryside in search of precious white and black truffles. Our work is driven by passion, but we also offer guided truffle hunting experiences, allowing enthusiasts to discover the fascinating world of truffle hunting. Join us on an adventure in the finest reserves of the Langhe and Monferrato, immersing yourself in tradition and nature as we guide you through enchanted woods in search of these hidden treasures.",
      cta: "Learn more",
      dogs: "Our dogs",
    },
    booked: {
      eyebrow: "Experiences",
      title: "Truffle hunting experiences",
      subtitle: "Live a unique adventure in the heart of Langhe and Monferrato",
      description:
        "Join us for an unforgettable truffle hunting experience: an adventure that will take you to explore the secrets of ancient forests and discover traditional harvesting techniques. Our guided experiences are designed for enthusiasts of all ages and experience levels.",
      includedTitle: "What's included",
      included: [
        { title: "Expert guide and truffle dog", description: "Your guide will be a local expert truffle hunter, accompanied by a dog trained in truffle hunting." },
        { title: "Truffle tasting", description: "At the end of the excursion, you will enjoy a tasting of fresh truffle, accompanied by a glass of local wine and typical local food." },
        { title: "Experience photos", description: "We capture the highlights of your adventure for memories that will last a lifetime." },
      ],
    },
    contact: {
      eyebrow: "Contact",
      title: "Get in touch",
      text: "Fill out the form to get in touch with us. We will respond as soon as possible.",
      name: "Name",
      surname: "Surname",
      email: "Email",
      message: "Message",
      interestsTitle: "What are you interested in?",
      interests: { hunt: "Truffle hunting", buy: "Buying truffles", info: "Information" },
      send: "Send request",
      sending: "Sending…",
      success: "Request sent successfully. We'll get back to you soon!",
      error: "Something went wrong while sending. Please try again shortly.",
      mailFallback: "We opened your email app with the message ready: press Send to deliver it to Milo's Truffle.",
      direct: "Or reach us directly",
      required: "Please fill in the required fields",
    },
    booking: {
      title: "Book your truffle hunt",
      people: "Number of people",
      tasting: "With tasting",
      noTasting: "Without tasting",
      days: "Preferred days",
      daysPlaceholder: "Let us know your preferred days…",
      allergies: "Any allergies?",
      allergiesLabel: "Specify your allergies",
      allergiesPlaceholder: "Enter any allergies…",
    },
    order: {
      title: "Request your truffle",
      intro: "Choose the quantity and leave your details: you will receive an email as soon as possible.",
      quantity: "Quantity in grams",
      phone: "Phone",
      address: "Address",
      note: "Notes (optional)",
      cancel: "Cancel",
      send: "Send order",
    },
    footer: {
      about:
        "Simone Gulino and Giulia Canton are a couple passionate about truffles. Together with their two loyal dogs, Milo and Stella, they search for truffles in the Italian countryside and offer guided experiences to all enthusiasts.",
      links: "Useful links",
      contacts: "Contact",
      rights: "All rights reserved.",
    },
    notFound: { title: "Page not found", text: "The page you are looking for does not exist or has moved.", cta: "Back to home" },
  },
};
